exports.selectionList = [
    {
        name: "Text",
        sample: "The quick brown fox jumps over 13 lazy dogs.",
    },
    {
        name: "Flipped",
        sample: ".sgod yzal 31 revo spmuj xof nworb kciuq ehT",
    },
    {
        name: "Decimal",
        sample:
            "84 104 101 32 113 117 105 99 107 32 98 114 111 119 110 32 102 111 120 32 106 117 109 112 115 32 111 118 101 114 32 49 51 32 108 97 122 121 32 100 111 103 115 46",
    },
    {
        name: "Binary",
        sample:
            "01010100 01101000 01100101 00100000 01110001 01110101 01101001 01100011 01101011 00100000 01100010 01110010 01101111 01110111 01101110 00100000 01100110 01101111 01111000 00100000 01101010 01110101 01101101 01110000 01110011 00100000 01101111 01110110 01100101 01110010 00100000 00110001 00110011 00100000 01101100 01100001 01111010 01111001 00100000 01100100 01101111 01100111 01110011 00101110",
    },
    {
        name: "Octal",
        sample:
            "124 150 145 40 161 165 151 143 153 40 142 162 157 167 156 40 146 157 170 40 152 165 155 160 163 40 157 166 145 162 40 61 63 40 154 141 172 171 40 144 157 147 163 56",
    },
    {
        name: "Hexadecimal",
        sample:
            "54 68 65 20 71 75 69 63 6b 20 62 72 6f 77 6e 20 66 6f 78 20 6a 75 6d 70 73 20 6f 76 65 72 20 31 33 20 6c 61 7a 79 20 64 6f 67 73 2e",
    },
];